module.exports = __webpack_public_path__ + "img/shop-plus.316c3b84.svg";